<template>
    <div id="ModalGridColumns">
      
        <b-modal 
              title="چـیـدمـان سـتـون هـای جـداول"

          :header-bg-variant="this.$store.state.ThemeLight == 'true'?'light':'dark'"
          :header-text-variant="this.$store.state.ThemeLight == 'true'?'dark':'light'"
          :body-bg-variant="this.$store.state.ThemeLight == 'true'?'light':'dark'"
          :body-text-variant="this.$store.state.ThemeLight == 'true'?'dark':'light'"
          :footer-bg-variant="this.$store.state.ThemeLight == 'true'?'light':'dark'"
          :footer-text-variant="this.$store.state.ThemeLight == 'true'?'dark':'light'"
          centered id="modal-scopedAlignColumns">

            <template #modal-header="{ close }">
              <b-button size="sm" variant="outline-danger" @click="close()">
                  <span aria-hidden="true">&times;</span>
              </b-button>
              <h5></h5>
            </template>

            <template #default>
              <loading v-if="loadingRender"></loading>
            <b-row>
              <b-col md="6" dir="rtl" >
                    <h6>ستون های آشکار</h6>
                    <draggable class="list-group border a" :list="list1" @end="onEnd" group="people">
                    <div class="list-group-item" v-for="(element, index) in list1" :key="element.id">
                        <div class="input-group">
                          
                        <input type="text" class="form-control" v-model="element.label" aria-describedby="basic-addon2" />
                        <div class="input-group-prepend">
                            <span class="input-group-text text-success" id="basic-addon2">{{ index }}
                            </span>
                        </div>
                        </div>
                    </div>
                    </draggable>
                </b-col>
                <b-col md="6" dir="rtl">
                    <h6>ستون های پنهان</h6>
                    <draggable class="list-group border a" :list="list2" @end="onEnd" group="people">
                    <div class="list-group-item" v-for="(element, index) in list2" :key="element.id">
                        <div class="input-group">
                        <input type="text" class="form-control" v-model="element.label" aria-describedby="basic-addon1"
                            readonly />
                        <div class="input-group-prepend">
                            <span class="input-group-text text-danger" id="basic-addon1">{{ index }}
                            </span>
                        </div>
                        </div>
                    </div>
                    </draggable>
                </b-col>
                
            </b-row>
                
            </template>

            <template  #modal-footer="{ cancel }">
            <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()">
                انصراف
            </b-button>
            <b-button size="sm" variant="success-dark" @click="EditDeta()">
                ثـبـت 
            </b-button>
            <!-- <button class="btn btn-success btn-sm text-center" @click="EditDeta()">  ثـبـت </button> -->
            
            </template>
        </b-modal>
    </div>
</template>
<script>
import Loading from '@/components/Loader/Loading.vue';

 import draggable from "vuedraggable";
export default {

    data(){
        return{
          loadingRender:false,
        columns:[],
        DataAxois: {ArryfildValue: {},Method: "post",Action: "ReadGridColumns",},
        DataAxoisGrid: {
          ArryfildValue: {
            SoftwareId: 2,
            UserId: 1,
            FormName: "frm",
            ShowView: 0,
          },
          Method: "post",
          Action: "ReadGridColumns",
        },
        DataAxiosUpdate: {
          ArryfildValue: {
            Id: null,
            tblSoftwareId: 2,
            tblUserId: 1,
            IsVisible: true,
            IndexCol: 0,
            NameDelxahSoton: "نام سیستم",
            FormName: "frmDastresiDB",
            ColumnName: "Dbname",
          },
          Method: "put",
          Action: "ReadGridColumns/",
          Token: this.$session.get("Token"),
          From: "Body",
        },
        list1: [],
        list2: [],
        listPrimery: [],
        ChengList: [],
        ChengListHide: [],
        model: {
          id: null,
          indexCol: null,
          label: "",
          name: "",
          visibility: null,
          width: null,
        },
        }
    },
    components: {
      draggable,
        Loading,
    },
    methods:{
      onEnd: function () {
        this.ChengList = this.list1;
        this.ChengListHide = this.list2;
      },
      EditDeta: function () {
        try {
          this.loadingRender=true;
          
          var FormNamed ='';
            // this.$store.state.ComponentInToModal.NorouteFormName != null ?
            // this.$store.state.ComponentInToModal.NorouteFormName :
            // "frm" + this.$route.name;
          if (this.$route.name.substring(0, 6) == "Detail") {
            FormNamed="frm"+this.$route.name.substring(6);
          }else{
            FormNamed="frm"+this.$route.name
          }
          var Url = this.$cookies.get('URL')
          var axios = require("axios");
          var data;
          var config;
          if (this.ChengList.length > 0) {
            if (this.ChengListHide.length > 0) {
              for (let j = 0; j < this.ChengListHide.length; j++) {
                this.ChengListHide[j].visibility = false;
              }
              for (let z = 0; z < this.ChengListHide.length; z++) {
                const element = this.ChengListHide[z];
                this.DataAxiosUpdate.ArryfildValue = {
                  Id: element.id,
                  tblSoftwareId: 2,
                  tblUserId: this.$session.get("UserInfo").tblUserId,
                  IsVisible: element.visibility,
                  IndexCol: element.indexCol,
                  NameDelxahSoton: element.label,
                  FormName: FormNamed,
                  ColumnName: element.name,
                  ShowView: 0,
                };

                data = JSON.stringify(this.DataAxiosUpdate.ArryfildValue);
                config = {
                  method: this.DataAxiosUpdate.Method,
                  url: Url + this.DataAxiosUpdate.Action + element.id,
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: data,
                };

                axios(config)
                  .then((res) => {
                    if (res.status == 200) {
                      // console.log(res.data)
                      this.$store.state.renderComponentGrid = false;
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true;
                        this.DataAxoisGrid.ArryfildValue = {
                          SoftwareId: 2,
                          UserId: 1,
                          FormName: FormNamed,
                          ShowView: 0,
                        };
                        this.$myAxoisGridColumns(this.DataAxoisGrid, true);
                      });
                    }
                  }).finally(()=>{
                    this.loadingRender=false;
                    this.$store.state.renderComponentGrid = false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true;
                          });
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              }
            }
            for (let i = 0; i < this.ChengList.length; i++) {
              this.ChengList[i].indexCol = i;
            }
            for (let index = 0; index < this.ChengList.length; index++) {
              const element = this.ChengList[index];
              this.DataAxiosUpdate.ArryfildValue = {
                Id: element.id,
                tblSoftwareId: 2,
                tblUserId: this.$session.get("UserInfo").tblUserId,
                IsVisible: true,
                IndexCol: element.indexCol,
                NameDelxahSoton: element.label,
                FormName: FormNamed,
                ColumnName: element.name,
                ShowView: 0,
              };

              data = JSON.stringify(this.DataAxiosUpdate.ArryfildValue);
              config = {
                method: this.DataAxiosUpdate.Method,
                url: Url + this.DataAxiosUpdate.Action + element.id,
                headers: {
                  "Content-Type": "application/json",
                },

                data: data,
              };

              axios(config)
                .then((res) => {
                  if (res.status == 200) {
                    // console.log(res.data)
                    this.$store.state.renderComponentGrid = false;
                    this.$store.state.renderComponentFilterForm = false;
                    this.$nextTick(() => {
                      this.$store.state.renderComponentGrid = true;
                      this.$store.state.renderComponentFilterForm = true;
                      this.DataAxoisGrid.ArryfildValue = {
                        SoftwareId: 2,
                        UserId: 1,
                        FormName: FormNamed,
                        ShowView: 0,
                      };
                      this.$myAxoisGridColumns(this.DataAxoisGrid, true);
                    });
                  }
                }).finally(()=>{
                  this.loadingRender=false;
                    this.$store.state.renderComponentGrid = false;
                        this.$nextTick(() => {
                                    this.$store.state.renderComponentGrid = true;
                        });
                })
                .catch(function (error) {
                  console.log(error);
                });
            }
          } else {
            if (this.list1 != null) {
              for (let index = 0; index < this.list1.length; index++) {
                const element = this.list1[index];
                this.DataAxiosUpdate.ArryfildValue = {
                  Id: element.id,
                  tblSoftwareId: 2,
                  tblUserId: 1,
                  IsVisible: true,
                  IndexCol: element.indexCol,
                  NameDelxahSoton: element.label,
                  FormName: FormNamed,
                  ColumnName: element.name,
                  ShowView: 0,
                };

                data = JSON.stringify(this.DataAxiosUpdate.ArryfildValue);
                config = {
                  method: this.DataAxiosUpdate.Method,
                  url: Url + this.DataAxiosUpdate.Action + element.id,
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: data,
                };

                axios(config)
                  .then((res) => {
                    if (res.status == 200) {
                      // console.log(res.data)
                      this.$store.state.renderComponentGrid = false;
                      this.$store.state.renderComponentFilterForm = false;
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true;
                        this.$store.state.renderComponentFilterForm = true;
                        this.DataAxoisGrid.ArryfildValue = {
                          SoftwareId: 2,
                          UserId: 1,
                          FormName: FormNamed,
                          ShowView: 0,
                        };
                        this.$myAxoisGridColumns(this.DataAxoisGrid, true);
                      });
                    }
                  }).finally(()=>{
                    this.loadingRender=false;
                    this.$store.state.renderComponentGrid = false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true;
                          });
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
     GetData(data){
      this.listPrimery =data;
      let listFinal = [];
      let listFinalHide = [];
      for (let index = 0; index < this.listPrimery.length; index++) {
        const element = this.listPrimery[index];
        if (element.visibility == true) {
          listFinal.push(element);
        } else {
          if (
            element.label != "" &&
            element.label != "عملیات ها" &&
            element.name != "row"
          ) {
            listFinalHide.push(element);
          }
        }
      }
      this.list1 = listFinal;
      this.list2 = listFinalHide;
      }
    },
    beforeMount(){
      let formName=''
      if (this.$route.name.substring(0, 6) == "Detail") {
        formName=this.$route.name.substring(6);
      }else{
        formName=this.$route.name
      }
      this.$route.name
      this.DataAxois.ArryfildValue={SoftwareId: 2,UserId: 1,FormName: "frm" + formName,ShowView: 0,};
           this.$GetColumns(this.DataAxois, true)
        .then((data) => {
          this.GetData(data);
        });
        
    }
}
</script>
<style scoped>
  .a {
    cursor: move;
    min-height: 200px;
  }
  .form-control{
    border-radius: 0%;
  }
</style>